/**
 * Created by fers on 23.05.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, IntlShape} from 'react-intl';

export default class Error extends React.Component {
    static propTypes = {
        error: PropTypes.object,
        viewWithData: PropTypes.object,
    };

    render() {
        let str = "";

        if (this.props.viewWithData && this.props.viewWithData.errorDescription) {
            str = this.props.viewWithData.errorDescription;
        } else if (this.props.error) {
            str = this.props.error.toString();
        }

        let shortMsg = str;
        if (str && str.length > 200) {
            shortMsg = str.substr(0, 200) + "...";
        }

        return (
            <div className="dativeryPlatformBox">
                <div className="dativeryPlatformTitle">
                    <div className={"channel-logo-32x32"}></div>
                </div>
                <div className="dativeryPlatformContent dativeryPlatformContentError text-danger">
                    <small><strong><i aria-hidden="true" className="fa fa-lg fa-exclamation-triangle"></i> <FormattedMessage defaultMessage="Error during showing data." id="error.internal.inBox" /></strong></small>
                    {str ? <small><code title={str}><br/>{shortMsg}</code></small> : null}
                </div>
            </div>
        );
    }
}
